import { Routes, Route, Navigate } from "react-router-dom";
import RootOutlet from "@/components/layout/RootOutlet";
import DashboardLayout from "@/components/layout/DashboardLayout";
import LandingPage from "@/components/landing/LandingPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersListPage from "@/pages/customers/CustomersListPage";
import CustomerDetailPage from "@/pages/customers/CustomerDetailPage";
import VehiclesListPage from "@/pages/vehicles/VehiclesListPage";
import VehicleDetailPage from "@/pages/vehicles/VehicleDetailPage";
import JobsListPage from "@/pages/jobs/JobsListPage";
import JobDetailPage from "@/pages/jobs/JobDetailPage";
import InvoicesListPage from "@/pages/invoices/InvoicesListPage";
import InvoiceCreatePage from "@/pages/invoices/InvoiceCreatePage";
import InvoiceDetailPage from "@/pages/invoices/InvoiceDetailPage";
import ReportsPage from "@/pages/reports/ReportsPage";
import SettingsLayout from "@/pages/settings/SettingsLayout";
import GeneralSettingsPage from "@/pages/settings/GeneralSettingsPage";
import BillingSettingsPage from "@/pages/settings/BillingSettingsPage";

export function AppRouter() {
  return (
    <Routes>
      <Route element={<RootOutlet />}>
        {/* Public */}
        <Route index element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Protected — all wrapped in DashboardLayout */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />

          <Route path="/customers" element={<CustomersListPage />} />
          <Route path="/customers/:id" element={<CustomerDetailPage />} />

          <Route path="/vehicles" element={<VehiclesListPage />} />
          <Route path="/vehicles/:id" element={<VehicleDetailPage />} />

          <Route path="/jobs" element={<JobsListPage />} />
          <Route path="/jobs/:id" element={<JobDetailPage />} />

          <Route path="/invoices" element={<InvoicesListPage />} />
          <Route path="/invoices/new" element={<InvoiceCreatePage />} />
          <Route path="/invoices/:id" element={<InvoiceDetailPage />} />

          <Route path="/reports" element={<ReportsPage />} />

          <Route path="/settings" element={<SettingsLayout />}>
            <Route path="general" element={<GeneralSettingsPage />} />
            <Route path="billing" element={<BillingSettingsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
